import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { database } from "../../appWrite"; // Adjust based on your setup
import { Models } from "appwrite"; // Import Appwrite's types

// Define the structure of an FAQ document
interface FAQ extends Models.Document {
  id: string;
  question: string;
  answer: string;
}

// Define state structure
interface FAQState {
  faqs: FAQ[];
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: FAQState = {
  faqs: [],
  loading: false,
  error: null,
};

// Fetch FAQs from Appwrite
export const fetchFAQs = createAsyncThunk("faq/fetchFAQs", async () => {
  try {
    const response = await database.listDocuments<FAQ>(
      "67ce8a4a0032e13c6368",
      "67d7ec6f0022005176aa"
    );
    return response.documents; // Now properly typed as FAQ[]
  } catch (error: any) {
    throw error.message || "Failed to fetch FAQs";
  }
});

const faqSlice = createSlice({
  name: "faq",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFAQs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFAQs.fulfilled, (state, action) => {
        state.loading = false;
        state.faqs = action.payload;
      })
      .addCase(fetchFAQs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
  },
});

export default faqSlice.reducer;
